// extracted by mini-css-extract-plugin
export default {"btn":"auth-button_btn__f3Z7T","light":"auth-button_light__06D1d"};